import { render, staticRenderFns } from "./TipImgPopup.vue?vue&type=template&id=2c51d03a&scoped=true&"
import script from "./TipImgPopup.vue?vue&type=script&lang=js&"
export * from "./TipImgPopup.vue?vue&type=script&lang=js&"
import style0 from "./TipImgPopup.vue?vue&type=style&index=0&id=2c51d03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51d03a",
  null
  
)

export default component.exports